import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { CasesService, listUserCaseOutput } from '../../service/cases.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { finalize, take, tap } from 'rxjs/operators';
import { MyCasesModalComponent } from '../my-cases/modal/my-cases-modal.component';
import { LeadDetailsModalComponent } from '../lead-details-modal/lead-details-modal.component';

@Component({
  selector: 'app-history-cases',
  templateUrl: './history-cases.component.html',
  styleUrls: ['./history-cases.component.scss'],
})
export class HistoryCasesComponent implements OnInit {
  loading: boolean = true;
  page: number = 1;
  pageLength: number = 10;

  myCasesHistory: listUserCaseOutput[];
  totalRows: number;

  constructor(
    private readonly service: CasesService,
    private readonly dialog: MatDialog,
    private readonly snack: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.myCasesList();
  }

  showCaseDetails(leadId: number) {
    this.dialog.open(LeadDetailsModalComponent, {
      data: { leadId },
      width: '700px',
    });
  }

  paginationChange(page: number) {
    this.page = page;
    this.myCasesList();
  }

  private myCasesList() {
    this.loading = true;

    const pagination = {
      page: this.page,
      perPage: this.pageLength,
    };

    this.service
      .findUserHistoryCases(pagination)
      .pipe(
        take(1),
        tap((response) => {
          this.myCasesHistory = response.data;
          this.totalRows = response.total;
        }),
        finalize(() => (this.loading = false))
      )
      .subscribe({
        error: (err) => {
          this.snack.open(
            err.message ??
              'Ocorreu um erro ao buscar por informações de leads adquiridos pelo usuário.'
          );
          this.loading = true;
        },
      });
  }
}
